import { useEffect, useState } from "react";
import FeatherIcon from "feather-icons-react";
import { Input, Loader, Modal, Tab } from "semantic-ui-react";

import { useSelector } from "react-redux";

import "./GlobalSearch.scss";
import { GlobalSearchQuery } from "src/graphql/globalSearch";
import { ResultsCard } from "./ResultsCard";
import { debounce } from "src/utils/debounce";

export const GlobalSearch = () => {
  // *********************** Variables ***********************
  const { selectedCompany } = useSelector((state) => state.companyList);
  const companyId = selectedCompany?.id;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchField, setSearchField] = useState("all");
  const [documentsFound, setDocumentsFound] = useState([]);
  const [transactionsFound, setTransactionsFound] = useState([]);
  const [agendasFound, setAgendasFound] = useState([]);
  const [previousSearches, setPreviousSearches] = useState(JSON.parse(localStorage.getItem(`searches-${companyId}`)) || []);

  const panes = [
    {
      menuItem: "Todo",
    },
    {
      menuItem: "Rut",
    },
    {
      menuItem: "Folio",
    },
    {
      menuItem: "Monto"
    },
  ];

  // *********************** Graph ***********************
  const { data: globalSearchData, fetching: globalSearchFetching } = GlobalSearchQuery({
    companyId,
    searchTerm,
    searchField
  });

  // *********************** logica ***********************
  const onSearch = async (value) => {
    const cleanedValue = value.replace(/[.-]/g, '');
    const updateSearchValue = debounce((text) => setSearchTerm(text), 300);

    if (cleanedValue != undefined) {
      updateSearchValue(cleanedValue.toLowerCase());
    }
  };

  const saveSearch = (search) => {
    const updatedSearches = [
      search,
      ...previousSearches.filter((previusSearch) => previusSearch?.id !== search?.id),
    ].slice(0, 5);

    setPreviousSearches(updatedSearches);
    localStorage.setItem(`searches-${companyId}`, JSON.stringify(updatedSearches));
  }

  const onModalClose = () => {
    setModalIsOpen(false);
    setSearchTerm("");
    setActiveIndex(0);
    setDocumentsFound([]);
    setTransactionsFound([]);
    setAgendasFound([]);
  }

  useEffect(() => {
    if (!globalSearchData) return;
    const searchResults = globalSearchData?.globalSearch?.data;

    setDocumentsFound(searchResults?.documents || []);
    setTransactionsFound(searchResults?.transactions || []);
    setAgendasFound(searchResults?.agendas || []);
  }, [globalSearchData]);

  useEffect(() => {
    const searchFields = ['all', 'rut', 'documentId', 'amount'];
    setSearchField(searchFields[activeIndex] || 'all');
  }, [activeIndex]);

  return (
    <Modal
      open={modalIsOpen}
      centered={false}
      onOpen={() => setModalIsOpen(true)}
      onClose={() => onModalClose()}
      trigger={
        <button className="tw-bg-transparent tw-border-none">
          <FeatherIcon icon="search" size={15} className="!tw-text-gray-500" />
        </button>
      }
      dimmer={{
        style: {
          zIndex: 9999,
          backgroundColor: "rgba(0,0,0,.6)",
          backdropFilter: "blur(3px)",
        },
      }}
      className="modal--container !tw-w-[750px] !tw-p-5 !tw-rounded-lg"
    >
      <Input
        icon={
          <i className="icon">
            <FeatherIcon icon="search" className="icon tw-text-gray-400" size={20} />
          </i>
        }
        iconPosition="left"
        placeholder="Buscar"
        className="tw-w-full !tw-h-[37px] !tw-text-base"
        onChange={(event) => onSearch(event.target.value)}
      />

      {
        globalSearchFetching ?
          <div className="tw-w-full tw-h-[156px] tw-flex tw-items-center tw-justify-center tw-mt-4">
            <Loader size='large' className="!tw-relative !tw-m-0 !tw-top-0 !tw-left-0 !tw-transform-none custom-loader" />
          </div>
          :
          previousSearches.length > 0 && !searchTerm ?
            <section className="!tw-text-sm tw-mt-5">
              <ResultsCard
                resultsName={'Últimas búsquedas'}
                results={previousSearches}
                onModalClose={onModalClose}
                saveSearch={saveSearch}
                searchTerm={searchTerm}
              />
            </section>
            : searchTerm &&
            <>
              <Tab
                panes={panes}
                activeIndex={activeIndex}
                menu={{ secondary: true, pointing: true }}
                onTabChange={(_, v) => setActiveIndex(v?.activeIndex)}
              />
              <section className="!tw-text-sm tw-mt-5">
                {(documentsFound.length > 0 || transactionsFound.length > 0 || agendasFound.length > 0) ?
                  <section className="tw-flex tw-flex-col tw-gap-4">
                    <ResultsCard
                      resultsName={'Movimientos'}
                      results={transactionsFound}
                      onModalClose={onModalClose}
                      saveSearch={saveSearch}
                      searchTerm={searchTerm}

                    />
                    <ResultsCard
                      resultsName={'Documentos'}
                      results={documentsFound}
                      onModalClose={onModalClose}
                      saveSearch={saveSearch}
                      searchTerm={searchTerm}
                    />
                    <ResultsCard
                      resultsName={'Agendas'}
                      results={agendasFound}
                      onModalClose={onModalClose}
                      saveSearch={saveSearch}
                      searchTerm={searchTerm}
                    />
                  </section >
                  :
                  <section className="tw-w-full tw-h-[438px] tw-bg-gray-50 tw-flex tw-flex-col tw-items-center tw-justify-center">
                    <div className="tw-rounded-full tw-bg-gray-100 tw-p-2">
                      <FeatherIcon icon="search" size={18} className="tw-text-gray-500" />
                    </div>
                    <p className="tw-text-lg tw-text-gray-600">No hay información para mostrar</p>
                  </section>
                }
              </section>
            </>
      }
    </Modal>
  );
};
